import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/images/siopas-logo.png';
import logoIcon from '../../assets/images/siopas-logo.png';
// import logoImage from '../../assets/images/bimage_indo.jpeg';
// import logoIcon from '../../assets/images/bimage.png';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';

// project imports
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
import { Box } from '@mui/material';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ reverse, isIcon, sx, to }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx}>
      {isIcon ? (
        <Box component="img" src={logoIcon} alt="Logo" sx={{ width: 40, height: 20 }} />
      ) : (
        <Box component="img" src={logoImage} alt="Logo" sx={{ width: '100%', height: 'auto', pr: 7, borderRadius: 2 }} />
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
